module.exports = __webpack_public_path__ + "static/media/6_Bono_de_Reconocimiento.abad1c7c.mp3";